import { BaseCoreConstants, delayedCall, dispatcher, EventConstants, IEvent, ingenuity, killDelayedCall, Loading } from "@quest/base-core";
import { GameLogic, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { EventConstantsLeander } from "@quest/oddsworks-platform";

export class GameClientLogic extends GameLogic {
  /**
   * This method is overried to subsscribe Cascade reel Event
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_CASCADE_WIN, this.onShowCascadeWin, this);
    dispatcher.on(eventDispatchers.ON_CASCADE_REELS, this.onCascadeReels, this);
    dispatcher.on(eventDispatchers.START_NEXT_CASCADE, this.startNextCascade, this);
    dispatcher.on(eventDispatchers.START_NEXT_LINE_TOGGLE, this.startNextLineToggle, this);
    dispatcher.on(eventDispatchers.ON_SHOW_NEXT_PRESENTATION, this.onShowNextPresentation, this);
  }

  /**
   * This method is overried to un-subsscribe Cascade reel Event
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_CASCADE_WIN, this.onShowCascadeWin, this);
    dispatcher.off(eventDispatchers.ON_CASCADE_REELS, this.onCascadeReels, this);
    dispatcher.off(eventDispatchers.START_NEXT_CASCADE, this.startNextCascade, this);
    dispatcher.off(eventDispatchers.START_NEXT_LINE_TOGGLE, this.startNextLineToggle, this);
    dispatcher.off(eventDispatchers.ON_SHOW_NEXT_PRESENTATION, this.onShowNextPresentation, this);
  }

  protected onShowNextWinPresentation(evt?: IEvent): void {
    const winSequenceCounter = this.model.getAnimationSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
    if (winSequenceCounter >= this.model.getAnimationSequence().length) {
      return;
    }
    const sequenceArray = this.model.getAnimationSequence(); // animation sequence array
    const currentWinEventToShow = sequenceArray[winSequenceCounter]; // current win presentation to show from win sequence
    switch (currentWinEventToShow) {
      case "showCascading":
        this.updateAnimationSequenceCounter();
        this.onShowCascadeWin();
        break;
      case "collectSpecial":
        this.updateAnimationSequenceCounter();
        this.onCollectSpecialSym();
        break;
      case "moneyHunting":
        this.updateAnimationSequenceCounter();
        this.onMoneyHunting();
        break;
      case "FGTriggeringAnimation":
        this.updateAnimationSequenceCounter();
        this.onFGTriggeringAnimation();
        break;
      case "clueRevealed":
        this.updateAnimationSequenceCounter();
        this.onClueRevealed();
        break;
      case "clueRewardMsgBanner":
        this.updateAnimationSequenceCounter();
        this.clueRewardMsgBanner();
        break;
      case "clueRewardCollection":
        this.updateAnimationSequenceCounter();
        this.clueRewardCollection();
        break;
      case "showGrandJP":
        this.updateAnimationSequenceCounter();
        this.showGrandJP();
        break;
      default:
        super.onShowNextWinPresentation(evt);
        break;
    }
  }

  private onClueRevealed(): void {
    if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
      if ((ingenuity.parserModel as GameParserModel).getClueRevealedFeatureStatus()) {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
          dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_AUTOPLAY_BEFORE_FEATURE);
          dispatcher.fireEvent(eventDispatchers.PLAY_REVEALED_CLUE_ANIMATION);
          dispatcher.fireEvent(eventDispatchers.INITIALIZE_CLUE_BANNER);
        } else {
          dispatcher.fireEvent(eventDispatchers.PLAY_REVEALED_CLUE_ANIMATION_FG);
          dispatcher.fireEvent(eventDispatchers.INITIALIZE_CLUE_BANNER);
          dispatcher.fireEvent(eventDispatchers.ADD_MSG_BANNER_ON_TOP);
        }
      } else {
        this.model.getIsWin() && dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        !this.model.getIsWin() && dispatcher.fireEvent(eventDispatchers.ON_SHOW_NEXT_PRESENTATION);
      }
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      dispatcher.on(
        EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED,
        (e) => {
          delayedCall(
            SlotConstantsBehavior.BIG_WIN_POSTLOAD,
            SlotConstantsBehavior.BIG_WIN_POSTLOAD_DELAY_INTERVAL,
            () => {
              killDelayedCall(SlotConstantsBehavior.BIG_WIN_POSTLOAD);
              this.onClueRevealed();
            },
            this
          );
        },
        this,
        true
      );
    }
  }
        /**
   * to make this unction Bspot specific
   */
  protected handleGameAfterErrorResolved(): void {
    if(ingenuity.configData.isBSPOTEnable){
      super.handleGameAfterErrorResolved();
    }
  }
  private showGrandJP(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsGrandJPAvailable()) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_GRAND_CLUE_BANNER);
      dispatcher.fireEvent(eventDispatchers.START_SUSPECT_REVEAL)
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  private clueRewardMsgBanner(): void {
    if ((ingenuity.parserModel as GameParserModel).getClueRevealedFeatureStatus()) {
      dispatcher.fireEvent(eventDispatchers.CLUE_REWARD_MSG_BANNER);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  private clueRewardCollection(): void {
    if ((ingenuity.parserModel as GameParserModel).getClueRevealedFeatureStatus()) {
      dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BANNER);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  private onMoneyHunting(): void {
    if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
      if ((ingenuity.parserModel as GameParserModel).getMoneyHuntingFetureStatus()) {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
          dispatcher.fireEvent(eventDispatchers.START_MONEY_HUNTING_FEATURE)
        } else {
          dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREE_GAME_WIN_METER);
          dispatcher.fireEvent(eventDispatchers.START_MONEY_HUNTING_FEATURE_FG);
        }
      } else {
        this.model.getIsWin() && dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      }
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      dispatcher.on(
        EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED,
        (e) => {
          delayedCall(
            SlotConstantsBehavior.BIG_WIN_POSTLOAD,
            SlotConstantsBehavior.BIG_WIN_POSTLOAD_DELAY_INTERVAL,
            () => {
              killDelayedCall(SlotConstantsBehavior.BIG_WIN_POSTLOAD);
              this.onMoneyHunting();
            },
            this
          );
        },
        this,
        true
      );
    }
  }

  // Add to start next line toggle
  private startNextLineToggle(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount() !== 0) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        this.hideBaseGameCascade();
      } else {
        this.hideFreeGameCascade();
      }
    } else {
      this.startNextCascade();
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState &&
        dispatcher.fireEvent(eventDispatchers.FORCE_STOP_QL_PLAYER_MESSAGE);
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState && dispatcher.fireEvent(eventDispatchers.FG_FORCE_STOP_QL_PLAYER_MESSAGE);
    }
  }


  // Hide base game cascade
  private hideBaseGameCascade(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_STACK_SYMBOL_WIN_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.HIDE_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.SHOW_SYM_WIN);
    dispatcher.fireEvent(eventDispatchers.START_STACK_SYMBOL_WIN_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.SHOW_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.SHOW_QL_PLAYER_MESSAGE);
  }

  // Hide free game cascade
  private hideFreeGameCascade(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_FG_STACK_SYMBOL_WIN_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.HIDE_FG_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.SHOW_FG_SYM_WIN);
    dispatcher.fireEvent(eventDispatchers.START_FG_STACK_SYMBOL_WIN_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.SHOW_FG_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.FG_SHOW_QL_PLAYER_MESSAGE);
  }

  private onCollectSpecialSym(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsSpecialSymbol()) {
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
        dispatcher.fireEvent(eventDispatchers.SPECIAL_SYMBOL_OUT_ANIM_FG);
      } else {
        dispatcher.fireEvent(eventDispatchers.SPECIAL_SYMBOL_OUT_ANIM);
      }
    } else {
      this.model.getIsWin() && dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      !this.model.getIsWin() && dispatcher.fireEvent(eventDispatchers.ON_SHOW_NEXT_PRESENTATION);
    }
  }

  protected doNextSpin(evt: IEvent): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    dispatcher.fireEvent(eventDispatchers.RESET_FS_BAR_RETRIGGER);
    this.saveDataRequest();
    super.doNextSpin(evt);
  }

  private saveDataRequest(): void {
    delayedCall('sendResquest', SlotConstantsBehavior.DURATION_100, () => {
      killDelayedCall('sendResquest');
      dispatcher.fireEvent(EventConstantsLeander.SAVE_DATA_REQUEST, this.getStickyFramesFG());
    })
  }

  private getStickyFramesFG(): any {
    let UserGameData = {
      name: "stickyFramesFG",
      data: (ingenuity.parserModel as GameParserModel).getStickyFramesPosition()
    }
    return UserGameData;
  }

  protected onSpinClicked(evt: IEvent): void {
    super.onSpinClicked(evt);
    dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER);
  }

  private onShowNextPresentation(evt?: IEvent): void {
    const winSequenceCounter = this.model.getNoWinSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
    if (winSequenceCounter >= this.model.getNoWinAnimationSequence().length) {
      return;
    }
    const sequenceArray = this.model.getNoWinAnimationSequence(); // animation sequence array
    const currentWinEventToShow = sequenceArray[winSequenceCounter]; // current win presentation to show from win sequence
    switch (currentWinEventToShow) {
      case "collectSpecial":
        this.updateNoWinSequenceCounter();
        this.onCollectSpecialSym();
        break;
      case "clueRevealed":
        this.updateNoWinSequenceCounter();
        this.onClueRevealed();
        break;
      default:
        this.sendGameCloseRequest();
        break;
    }
  }

  private sendGameCloseRequest(): void {
    this.sendCloseRequest();
    this.resetNoWinSequenceCounter();
  }

  private resetNoWinSequenceCounter(): void {
    this.model.setNoWinSequenceCounter(0);
  }

  private updateNoWinSequenceCounter(): void {
    // this.model.updateAnimationSequenceCounter();
    if (this.model.getNoWinSequenceCounter() < this.model.getNoWinAnimationSequence().length) {
      this.model.updateNoWinSequenceCounter();
    }
  }

  /**
   * This method is to show next cascade
   */
  private startNextCascade(): void {
    killDelayedCall(gameConstants.NEXT_LINE_TOGGLE);
    ingenuity.configData.stageClickOnCascade = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
    (ingenuity.parserModel as GameParserModel).setCascadeLineToggleCount(0);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.FORCE_STOP_QL_PLAYER_MESSAGE);
      dispatcher.fireEvent(eventDispatchers.HIDE_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.HIDE_STACK_SYMBOL_WIN_ANIMATION);
    } else {
      dispatcher.fireEvent(eventDispatchers.FG_FORCE_STOP_QL_PLAYER_MESSAGE);
      dispatcher.fireEvent(eventDispatchers.HIDE_FG_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.HIDE_FG_STACK_SYMBOL_WIN_ANIMATION);
    }
    if ((ingenuity.parserModel as GameParserModel).getCascadingCount() !== 0) {
      dispatcher.fireEvent(eventDispatchers.PARSE_NEXT_CASCADE_DATA);
    }
  }

  /**
   * This method will check for cascade reels
   */
  private onCascadeReels(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadeWin()) {
      this.setWinlineAndWaysData();
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.BURST_SYMBOLS);
    } else {
      dispatcher.fireEvent(eventDispatchers.FG_BURST_SYMBOLS);
    }
  }

  /**
   * This method is use to show cascade
   */
  private onShowCascadeWin(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        this.startBaseGameCascade();
      } else {
        this.startFreeGameCascade();
      }
      this.startWinMeterTickUP();
      ingenuity.configData.stageClickOnCascade = true;
      dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  // Start base game cascade
  private startBaseGameCascade(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_SYM_WIN);
    dispatcher.fireEvent(eventDispatchers.INITIALIZE_STACK_SYMBOL_WIN);
    dispatcher.fireEvent(eventDispatchers.START_STACK_SYMBOL_WIN_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.INITIALIZE_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.SHOW_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.SHOW_QL_PLAYER_MESSAGE);
  }

  // Start free game cascade
  private startFreeGameCascade(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_FG_SYM_WIN);
    dispatcher.fireEvent(eventDispatchers.INITIALIZE_FG_STACK_SYMBOL_WIN);
    dispatcher.fireEvent(eventDispatchers.START_FG_STACK_SYMBOL_WIN_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.INITIALIZE_FG_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.SHOW_FG_CLUSTER_WIN_FRAME);
    dispatcher.fireEvent(eventDispatchers.FG_SHOW_QL_PLAYER_MESSAGE); // enabel later
  }

  protected onShowBigWin(): void {
    if (
      this.model.getIsBigWin() &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
        this.startTheBigWinPresentation();
        dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
        dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(
          EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED,
          (e) => {
            delayedCall(
              SlotConstantsBehavior.BIG_WIN_POSTLOAD,
              SlotConstantsBehavior.BIG_WIN_POSTLOAD_DELAY_INTERVAL,
              () => {
                killDelayedCall(SlotConstantsBehavior.BIG_WIN_POSTLOAD);
                this.onShowBigWin();
              },
              this
            );
          },
          this,
          true
        );
      }
    } else if (this.model.getIsBigWin() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREESPIN_COUNTER); // GP4:To Hide free game count during bigwin in Free Game
      this.startTheBigWinPresentation();
      dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  protected onTriggeringAnimation(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered()) {
      dispatcher.fireEvent(eventDispatchers.SHOW_FS_BAR_WIN);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  protected onFGTriggeringAnimation(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(eventDispatchers.SHOW_FS_BAR_WIN_FG);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  protected onCheckForWinAfterReelStop(evt: IEvent): void {
    if (!this.model.getIsWin() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
      this.onShowNextPresentation();
    } else {
      if (
        (ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() ||
        (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()
      ) {
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      }
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
        dispatcher.fireEvent(SlotEventConstants.FG_SHOW_SPIN_BTN_HIDE_STOP_BTN);
      } else {
        dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
      }
      if (
        (this.model.getIsWin() && (ingenuity.parserModel as GameParserModel).getTotalWin()) ||
        (ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() ||
        (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
        this.setWinlineAndWaysData();
        killDelayedCall(SlotConstantsBehavior.BROKEN_DELAY_FG);
        this.showNextWinPresentation();
      } else {
        delayedCall(SlotConstantsBehavior.NoWinDelay, SlotConstantsBehavior.setDelayForNoWin, () => {
          killDelayedCall(SlotConstantsBehavior.NoWinDelay);
          dispatcher.fireEvent(SlotEventConstants.SHOW_CONTAINERS, SlotConstantsBehavior.ButtonsContainerId);
        });
      }
      (ingenuity.parserModel as GameParserModel).setisSpinStarted(false);
    }
  }

  /**
   * Method overrided to change delay time
   */
  protected doNextSpinInFreeGame():void {
    delayedCall(
      "nextSpinDelay",
      500,
      () => {
        killDelayedCall("nextSpinDelay");
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREE_GAME_WIN_METER);
        dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
      },
      this
    );
  }
  // TODO: Shift code to behavior
  protected checkForAutoPlay(): void {
    let delayTime = 0;
    if (this.model.getIsBigWin() && !ingenuity.configData.AutoplayBtnClicked) {
      delayTime = SlotConstantsBehavior.AutoPlayDelayBigWin;
    }
    else if (this.model.getIsWin() && !ingenuity.configData.AutoplayBtnClicked) {
      delayTime = SlotConstantsBehavior.AutoPlayDelayWin;
    }
    ingenuity.configData.AutoplayBtnClicked = false;
    delayedCall("autoplaydelay", delayTime, () => {
      if (this.model.getIsAutoPlayLeft()) {
        dispatcher.fireEvent(SlotEventConstants.SPIN_CLICKED);
      } else {
        dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
      }

    });
  }
}
